import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { useCustomer } from "../lib/CustomerContext";
import { Anchor, User, Mail, Lock } from "lucide-react";

export default function CustomerAuth() {
    const [mode, setMode] = useState("login"); // login | register
    const [form, setForm] = useState({
        email: "",
        password: "",
        firstName: "",
        lastName: "",
    });
    const [submitting, setSubmitting] = useState(false);
    const { login, register } = useCustomer();
    const navigate = useNavigate();

    async function submit(e) {
        e.preventDefault();
        setSubmitting(true);
        try {
            if (mode === "login") {
                await login(form.email, form.password);
                toast.success("Bentornato pirata!");
            } else {
                await register(form);
                toast.success("Ciurma completa! Sei a bordo.");
            }
            navigate("/account");
        } catch (err) {
            toast.error(err.message || "Errore autenticazione");
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <div
            className="max-w-md mx-auto px-5 py-16"
            data-testid="customer-auth-page"
        >
            <div className="text-center mb-8">
                <div className="font-hand text-2xl text-bounty">
                    accedi alla ciurma
                </div>
                <h1 className="font-display text-5xl tracking-tight">
                    {mode === "login" ? "ACCEDI" : "UNISCITI"}
                </h1>
            </div>

            <motion.form
                key={mode}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                onSubmit={submit}
                className="bounty-card p-8 space-y-4"
            >
                {mode === "register" && (
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="font-mono text-xs tracking-widest uppercase">
                                Nome
                            </label>
                            <input
                                required
                                value={form.firstName}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        firstName: e.target.value,
                                    })
                                }
                                className="input-manga mt-1"
                                data-testid="auth-firstname-input"
                            />
                        </div>
                        <div>
                            <label className="font-mono text-xs tracking-widest uppercase">
                                Cognome
                            </label>
                            <input
                                required
                                value={form.lastName}
                                onChange={(e) =>
                                    setForm({
                                        ...form,
                                        lastName: e.target.value,
                                    })
                                }
                                className="input-manga mt-1"
                                data-testid="auth-lastname-input"
                            />
                        </div>
                    </div>
                )}
                <div>
                    <label className="font-mono text-xs tracking-widest uppercase flex items-center gap-1">
                        <Mail size={12} /> Email
                    </label>
                    <input
                        type="email"
                        required
                        value={form.email}
                        onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                        }
                        className="input-manga mt-1"
                        data-testid="auth-email-input"
                    />
                </div>
                <div>
                    <label className="font-mono text-xs tracking-widest uppercase flex items-center gap-1">
                        <Lock size={12} /> Password
                    </label>
                    <input
                        type="password"
                        required
                        minLength={5}
                        value={form.password}
                        onChange={(e) =>
                            setForm({ ...form, password: e.target.value })
                        }
                        className="input-manga mt-1"
                        data-testid="auth-password-input"
                    />
                </div>
                <button
                    type="submit"
                    disabled={submitting}
                    className="btn-manga btn-manga-red w-full"
                    data-testid="auth-submit-btn"
                >
                    <Anchor size={14} className="mr-2" />
                    {submitting
                        ? "Salpando..."
                        : mode === "login"
                          ? "Accedi"
                          : "Unisciti"}
                </button>

                <div className="text-center pt-2 text-sm">
                    {mode === "login" ? (
                        <>
                            Nuovo pirata?{" "}
                            <button
                                type="button"
                                onClick={() => setMode("register")}
                                className="font-bold text-bounty underline"
                                data-testid="auth-switch-register"
                            >
                                Unisciti alla ciurma
                            </button>
                        </>
                    ) : (
                        <>
                            Sei già un pirata?{" "}
                            <button
                                type="button"
                                onClick={() => setMode("login")}
                                className="font-bold text-bounty underline"
                                data-testid="auth-switch-login"
                            >
                                Accedi
                            </button>
                        </>
                    )}
                </div>
            </motion.form>

            <p className="text-center mt-6 font-mono text-xs text-ink/60">
                Il tuo account è gestito da Shopify · SSL sicuro
            </p>
            <div className="text-center mt-3">
                <Link
                    to="/"
                    className="font-hand text-lg text-bounty hover:underline"
                >
                    ← torna alla home
                </Link>
            </div>
        </div>
    );
}
